import React, {PropTypes} from 'react';
import Cookies from 'universal-cookie';
import {Link} from 'react-router-dom';
import {API} from '../../../settings.js';
import {ajaxGet} from '../../../helpers/apiData.js';
import {favCheck} from '../../../helpers/favCheck.js';
import {imagesLoaded} from '../../../helpers/imagesLoadCheck.js';
import {FormattedMessage} from 'react-intl';

import RestaurantError from '../../RestaurantError';
import ListItem from './ListItem';
import FavBtn from './FavBtn';

import EmptyFav from './EmptyFav';
import PreLoader from "../../PreLoader";

const cookies = new Cookies();


class ShortList extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    view_info: PropTypes.func,
    wine_slug: PropTypes.string,
    favsTotal: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.list = '';

    this.state = {
      toggle: 'inactive',
      data: {products: null, status: ''},
      clear_list: false,
      loading: 'loading',
      list_width: 0,
      favList: []
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleFavs = this.handleFavs.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.getData = this.getData.bind(this);
  }


  componentDidMount() {
    this.lang = this.props.match.params.lang;
    this.restId = this.props.match.params.restaurant;
    if (cookies.get('shortlist') !== undefined) {
      this.setState({FavList: cookies.get('shortlist')});
    }
    this.getData();

    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      //title
      'myPick',
      //view
      'shortlist',
      //back button or not
      false
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (this.props !== nextProps || this.state !== nextState);
  }


  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  handleLoading() {
    this.setState({
      loading: imagesLoaded(this.list),
    });
  }

  updateDimensions() {
    if (window.innerWidth > 1024) {
      if (this.state.data.filters && this.state.data.filters.length !== 0) {
        this.setState({list_width: window.innerWidth - 420});
      }
      else {
        this.setState({list_width: window.innerWidth - 120});
      }
    }
    this.setState({list_width: window.innerWidth});
  }

  getData() {
    //TODO: Fazer com que deixe de ser necessário chamar a API quando se "desfavorita" um item
    //CHECKING IF THERE WERE NEW PROPS; WHICH MEANT THE USER WENT FROM LIST TO LIST, NEED TO MAKE SURE API CALL IS MADE
    //WITH THE NEW PROPS
    let query = '?' + cookies.get('shortlist');
    ajaxGet(API + this.lang + '/api/' + this.restId + '/items/favourites/' + query, this);
  }

  //HANDLING THE FILTER BTN TOGGLE
  handleClick() {
    if (this.state.toggle === 'inactive') {
      this.setState({toggle: 'active', overlay: 'active', navToggle: 'inactive'});
    } else {
      this.setState({toggle: 'inactive', overlay: 'inactive'});
    }
  }

  handleFavs(total) {
    this.props.favsTotal(total);
  }

  mapItemArray(item_list) {
    return item_list.map((item) => {
      let fav = favCheck(item.id, item.item_type);
      return (
        <div className={'list-item' + ' ' + fav} key={item.id}>
          <Link to={'/' + this.lang + '/' + this.restId + `/items/` + item.category
          + `/` + item.slug + '-' + item.id}>
            <ListItem name={item.title}
                      gallery={item.gallery[0]} description={item.description}
                      price={item.price} likes={item.like} list="true" itemType={item.item_type}
                      category={item.category} region={item.wine_region}
                      type={item.wine_type} template={this.state.data.template} pk={item.id}
                      favList={fav} unit={item.unit}
            />
          </Link>
          <FavBtn itemType={item.item_type} pk={item.id} onClick={this.handleFavs}/>
        </div>
      );
    });

  }

  renderResults() {
    let width = {
      width: this.state.list_width
    };
    let listFood = [];
    let listDrink = [];

    //CHECK IF THERE ARE ANY RESULTS IN THE RESPONSE
    if (this.state.data.products.food.length > 0 || this.state.data.products.drink.length > 0) { // CHECK IF API RESPONSE HAS ARRIVED
      // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING
      listFood = this.mapItemArray(this.state.data.products.food);
      listDrink = this.mapItemArray(this.state.data.products.drink);

      return (
        <div className={'item-list shortlist ' + this.state.loading + ' ' + this.state.toggle}
             style={width} onLoad={this.handleLoading} ref={(el) => {this.list = el;}}>
          <h3>myPick</h3>
          <FormattedMessage id="mypick-text">
            {(message) => <p className="empty-text">{message}</p>}
          </FormattedMessage>
          <button className="btn body-back-btn" onClick={this.props.history.goBack}/>
          {this.state.data.products.food.length > 0 ?
            <div className="list-wrapper">
              {listFood}
            </div>
            : null
          }
          {this.state.data.products.drink.length > 0 ?
            <div className="list-wrapper">
              {listDrink}
            </div>
            : null
          }
        </div>
      );
    }
    else { // NO RESULTS WERE FOUND, RENDER A MSG
      return (
        <div className={"item-list " + this.state.loading} style={width} onLoad={this.handleLoading}
             ref={(el) => {this.list = el;}}>
          <EmptyFav/>
        </div>
      );
    }
  }


  render() {
    // CHECKING FOR ERRORS FROM THE API
    if (this.state.data.status === "error") {
      return (
        <RestaurantError restaurant={this.restId}
                         lang={this.lang}
                         wine_slug={this.props.wine_slug}
                         view="api"/>
      );
    }

    return (
      <div className="content-wrapper">
        {/* showing the pre-loader until images are loaded */}
        <PreLoader loading={this.state.loading}/>
        {/* Once images are loaded, call the function that maps the products and renders them */}
        {this.state.data.products !== null ? this.renderResults() : null}
      </div>
    );
  }
}

export default ShortList;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/ShortList.js
 **/